import React from "react";
import { ButtonProps } from "./Button.types";

import "./Button.scss";

export const Button: React.FC<ButtonProps> = ({ btnStyle= 'primary',customClass, text='Button', type, disabled = false, onPress }) => {
  return(
    <button type={type ? type : 'button'} disabled={disabled} onClick={(e:React.MouseEvent<HTMLElement>)=> {
      if (typeof onPress=="function") {
        e.preventDefault();
        onPress();
      }
    }} className={customClass ? `button ${customClass} ${btnStyle}` : `button ${btnStyle}`}>{text}</button>
  )
};

